import * as React from 'react';

interface IWidgetLinkProps {
    onLinkClick: Function,
    disabled: boolean,
    color: string,
}

export default class WidgetLink extends React.Component<IWidgetLinkProps, void> {
    static propTypes = {
        onLinkClick: React.PropTypes.func.isRequired,
        disabled: React.PropTypes.bool,
        color: React.PropTypes.string.isRequired,
    };

    render() {
        let { children } = this.props;
        const { disabled, onLinkClick, color } = this.props;

        let handler = onLinkClick;

        if (disabled) {
            handler = () => { };
        }

        children = React.Children.map(children, (child) => {
            if(typeof child === 'string' && child.indexOf(':') > 0) {
                const parts: any[] = child.split(':');
                parts[0] = <i>{parts[0]}</i>;
                return parts;
            }
            return child;
        });

        return (<a onClick={() => handler()} className="se-widget-link" style={{ borderLeftColor: color }}>{children}</a>);
    }
}


// WEBPACK FOOTER //
// ./src/components/widgetMenu/WidgetLink.tsx